import { useEffect, useState } from "react";

export function useScrollThreshold(thresholdPx: number) {
  const [active, setActive] = useState(false);

  useEffect(() => {
    function handleScroll() {
      setActive(window.scrollY > thresholdPx);
    }

    window.addEventListener("scroll", handleScroll, { passive: true });

    handleScroll();

    return function dispose() {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [thresholdPx]);

  return active;
}
